import * as actions from '../actionTypes'
const initialState  = [];


const enrollmentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.DELETE_ENROLLMENT:
            return state.filter((enrollment) => enrollment._id !== action.payload);
        case actions.SET_ENROLLMENTS:
            return action.payload;

        case actions.ADD_ENROLLMENT:
            return [...state, action.payload];

        case actions.UPDATE_ENROLLMENT: {
            return state.map((enrollment) => enrollment._id === action.payload._id ? action.payload : enrollment);
        }
        default:
            return state;
    }
};

export default enrollmentsReducer;

